export default "dist/fonts/30BCD6_8_0.eot";